export default {
    '1270627954151059458':'安消摄像机',
    '1270627284745777154':'云台摄像机',
    '1270627504376311809':'高清球机',
    '1270628169079779330':'可视化烟感',
    '1278520532375302146':'全球眼',// flv
}